<template>
    <div v-if="props.uiMode === 'light'" :style="cssBinds[0][0]">
        <v-divider :class="classBinds[0]" :style="cssBinds[0][1]" :thickness="dividerThickness" :opacity="dividerOpacity"  />
        <DeviceLocation :uiMode="props.uiMode" :deviceLocation="props.deviceLocation" />
        <SearchPeriod :uiMode="props.uiMode" :period="props.period" />

        <v-divider :class="classBinds[0]" :style="cssBinds[0][1]" :thickness="dividerThickness" :opacity="dividerOpacity"  />
        <div :style="cssBinds[0][2]">
            <ChartVoltage v-for="data in graphData" :key="data.name" :uiMode="props.uiMode" :item="data" />
            <v-divider :class="classBinds[0]" :style="cssBinds[0][1]" :thickness="dividerThickness" :opacity="dividerOpacity"  />
        </div>

    </div>
    <div v-else :style="cssBinds[1][0]">
        <v-divider :class="classBinds[0]" :style="cssBinds[1][1]" :thickness="dividerThickness" :opacity="dividerOpacity"  />
        <DeviceLocation :uiMode="props.uiMode" :deviceLocation="props.deviceLocation" />
        <SearchPeriod :uiMode="props.uiMode" :period="props.period" />

        <v-divider :class="classBinds[0]" :style="cssBinds[1][1]" :thickness="dividerThickness" :opacity="dividerOpacity"  />
        <div :style="cssBinds[1][2]">
            <ChartVoltage v-for="data in graphData" :key="data.name" :uiMode="props.uiMode" :item="data" />
            <v-divider :class="classBinds[0]" :style="cssBinds[1][1]" :thickness="dividerThickness" :opacity="dividerOpacity"  />
        </div>
    </div>
</template>

<script setup>
import { defineExpose, onMounted, onUpdated, reactive } from "vue";
import { faLog,  } from "../common/faCommon.js";
import DeviceLocation from "./DeviceLocation.vue";
import SearchPeriod from "./SearchPeriod.vue";
import ChartVoltage from "./ChartVoltage.vue";

const FN = "[DeviceData] ";
const props = defineProps({
    uiMode: { type: String, required: true },
    deviceLocation: { type: Object, required: true },
    period: { type: Object, required: true },
    graphData: { type: Array, required: true },
});

const graphData = reactive([]);
const onUpdateGraph = () => {
    graphData.splice(0, graphData.length);
    for (let m = 0; m < props.graphData.length; m++) {
        graphData.push({
            name: props.graphData[m].name,
            number: props.graphData[m].number,
            role: props.graphData[m].role,
            voltages: props.graphData[m].dataList.voltageList,
            ranges: props.graphData[m].dataList.rangeList,
        });
    }
};

defineExpose({
    onUpdateGraph,
});

onUpdated(() => {
    faLog(0, FN + "[onUpdated] ");
});

onMounted(() => {
    faLog(0, FN + "[onMounted] ");
});

const dividerThickness = "1";
const dividerOpacity = "50";

const classBinds = ["mt-0 pa-0"];

const cssBinds = [
    [
        {
            backgroundColor: "white",
            width: "100%",
            height: "calc(100%)",
            overflowY: "hidden",
            overflowX: "auto",
        },
        {
            color: "#cccccc",
        },
        {
            width: "100%",
            height: "100%",
            overflowY: "auto",
            overflowX: "auto",
        },
    ],
    [
        {
            backgroundColor: "black",
            width: "100%",
            height: "calc(100%)",
            overflowY: "hidden",
            overflowX: "auto",
        },
        {
            color: "#505050",
        },
        {
            width: "100%",
            height: "100%",
            overflowY: "auto",
            overflowX: "auto",
        },
    ],
];
</script>